/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDobbiesCookiesInformationProps } from './dobbies-cookies-information.props.autogenerated';
import { Table } from 'reactstrap';

export interface IDobbiesCookiesInformationViewProps extends IDobbiesCookiesInformationProps<{}> {
    heading?: React.ReactNode;
    paragraph?: React.ReactNode;
    table?: React.ReactNode;
}

/**
 *
 * DobbiesCookiesInformation component
 * @extends {React.PureComponent<IDobbiesCookiesInformationProps<IDobbiesCookiesInformationData>>}
 */
class DobbiesCookiesInformation extends React.PureComponent<IDobbiesCookiesInformationProps<{}>> {
    private renderTable = () => {
        const { nameHeadingText, providerHeadingText, purposeHeadingText, expiryHeadingText, typeHeadingText } = this.props.resources;
        return (
            <Table responsive className='cookie-information-table'>
                <thead>
                    <tr>
                        <th>{nameHeadingText}</th>
                        <th>{providerHeadingText}</th>
                        <th>{purposeHeadingText}</th>
                        <th>{expiryHeadingText}</th>
                        <th>{typeHeadingText}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.config.cookies?.map(cookie => (
                        <tr key=''>
                            <td>{cookie.name}</td>
                            <td>{cookie.provider}</td>
                            <td>{cookie.purpose}</td>
                            <td>{cookie.expiry}</td>
                            <td>{cookie.type}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        );
    };

    public render(): JSX.Element | null {
        const { heading, paragraph, cookies } = this.props.config;
        const viewProps = {
            ...this.props,
            heading: heading?.text && <Msdyn365.Text className='ms-content-block__title' tag={heading.tag ?? 'h1'} text={heading.text} />,
            paragraph: paragraph && <Msdyn365.RichTextComponent text={paragraph} />,
            table: cookies?.length ? this.renderTable() : null
        };
        return this.props.renderView(viewProps);
    }
}

export default DobbiesCookiesInformation;
